// You can write more code here

/* START OF COMPILED CODE */

/* START-USER-IMPORTS */
import { ProgressBarBrain } from '@/game/GameComponents/PhaserGame/UI/ProgressBarBrain';
/* END-USER-IMPORTS */

export default class ProgressBarSmall extends Phaser.GameObjects.Container {
  constructor(scene: Phaser.Scene, x?: number, y?: number) {
    super(scene, x ?? 0, y ?? 0);

    this.scaleX = 2;
    this.scaleY = 2;

    // barBacking
    const barBacking = scene.add.image(0, 0, 'ProgressBarOutside-short');
    barBacking.setOrigin(0, 0.5);
    this.add(barBacking);

    // barFill
    const barFill = scene.add.image(0, 0, 'ProgressBarInside-short');
    barFill.setOrigin(0, 0.5);
    this.add(barFill);

    // barMask
    const barMask = scene.add.rectangle(0, 0, 160, 16);
    barMask.setOrigin(0, 0.5);
    barMask.alpha = 0;
    barMask.isFilled = true;
    this.add(barMask);

    this.barBacking = barBacking;
    this.barFill = barFill;
    this.barMask = barMask;

    /* START-USER-CTR-CODE */
    this.brain = new ProgressBarBrain(this);
    /* END-USER-CTR-CODE */
  }

  public barBacking: Phaser.GameObjects.Image;
  public barFill: Phaser.GameObjects.Image;
  public barMask: Phaser.GameObjects.Rectangle;

  /* START-USER-CODE */

  // Write your code here.
  public brain: ProgressBarBrain;

  destroy() {
    this.brain.destroy();
  }
  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
